import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["button"]

  async generate(event) {
    event.preventDefault()
    const button = this.buttonTarget
    const originalText = button.textContent

    button.disabled = true
    button.textContent = "生成中..."

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      if (!response.ok) {
        const data = await response.json()
        throw new Error(data.error || "生成に失敗しました")
      }

      const data = await response.json()
      await this.copyToClipboard(data.message)

      button.textContent = "コピーしました！"
      button.classList.add("bg-green-500")
      button.classList.remove("bg-gray-500", "hover:bg-gray-600")

      setTimeout(() => {
        button.textContent = originalText
        button.disabled = false
        button.classList.remove("bg-green-500")
        button.classList.add("bg-gray-500", "hover:bg-gray-600")
      }, 3000)
    } catch (error) {
      button.textContent = originalText
      button.disabled = false
      alert(error.message)
    }
  }

  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }
  }
}
